var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"topic",staticClass:"topic-box"},_vm._l((_vm.list),function(item){return _c('Item',_vm._b({key:item.id},'Item',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }